export default function openFile(file, type) {
    if (type === 'file') {
        window.open(this.$fileRoute + file, '_blank');
    }
    else { window.open(this.$imageRoute + file, '_blank'); }
}